import { cn } from '../../../utils'
import { BaseField, ValidationIcon } from '../base-field/BaseField'
import inputStyles from '../base-field/input/Input.module.css'
import styles from './TextArea.module.css'
import { TextAreaProps } from './TextArea.types'

function TextArea(props: TextAreaProps) {
  const {
    ref,
    children,
    value,
    status,
    className,
    name,
    label,
    helpText,
    feedbackText,
    attributes,
    ariaLabel,
    iconRight,
    formFieldClass,
    optionalLabel,
    ...rest
  } = props

  return (
    <BaseField {...props} className={cn(styles.textArea, className)}>
      <textarea
        ref={ref}
        className={cn(inputStyles.input, styles.textareaElement, className)}
        value={value}
        id={name}
        name={name}
        {...rest}
      >
        {Boolean(!value) && children}
      </textarea>
      <div className={styles.validationIcon}>
        <ValidationIcon status={status ?? 'default'} />
      </div>
    </BaseField>
  )
}

export default TextArea
